// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getAuth, initializeAuth, indexedDBLocalPersistence } from 'firebase/auth';
import { getFirestore, enableIndexedDbPersistence, CACHE_SIZE_UNLIMITED } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: "AIzaSyB_mbOl5VyHwM7jitYbpTJkRelbFyZVxD8",
    authDomain: "white-doves-ministry.firebaseapp.com",
    databaseURL: "https://white-doves-ministry-default-rtdb.firebaseio.com",
    projectId: "white-doves-ministry",
    storageBucket: "white-doves-ministry.firebasestorage.app",
    messagingSenderId: "1055532339208",
    appId: "1:1055532339208:web:09f8ab4e5a79c0f73c01bd",
    measurementId: "G-NP3H9NW8T4"
};

// Initialize Firebase
console.log('Initializing Firebase...');

let app;
let auth;
let db;
let storage;
let messaging;

try {
    app = initializeApp(firebaseConfig);
    
    // Initialize Auth with offline persistence
    auth = initializeAuth(app, {
        persistence: indexedDBLocalPersistence
    });
    
    // Initialize Firestore
    db = getFirestore(app);
    
    // Enable offline persistence for Firestore
    enableIndexedDbPersistence(db, {
        cacheSizeBytes: CACHE_SIZE_UNLIMITED
    }).catch((err) => {
        if (err.code === 'failed-precondition') {
            console.warn('Multiple tabs open, persistence can only be enabled in one tab at a time. Offline features may be limited.');
        } else if (err.code === 'unimplemented') {
            console.warn('Browser doesn\'t support IndexedDB persistence. Offline features will not work.');
        } else {
            console.error('Error enabling Firestore persistence:', err);
        }
    });
    
    storage = getStorage(app);
    messaging = getMessaging(app);
    
    console.log('Firebase initialized successfully with offline support');
    console.log('Auth:', !!auth);
    console.log('Firestore:', !!db);
    console.log('Storage:', !!storage);
    console.log('Firestore persistence enabled for offline support');
} catch (error) {
    console.error('Error initializing Firebase:', error);
}

// Export everything as named exports
export { app, auth, db, storage, messaging };

// Also export as default for flexibility
export default app;
